export default __webpack_public_path__ + "static/media/mobile_beehive_status_2_en.f8d97726.png";